import { render, staticRenderFns } from "./procedures-editor-history.vue?vue&type=template&id=d2276fe2"
import script from "./procedures-editor-history.vue?vue&type=script&lang=js"
export * from "./procedures-editor-history.vue?vue&type=script&lang=js"
import style0 from "./procedures-editor-history.vue?vue&type=style&index=0&id=d2276fe2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports